import React, { useState } from "react";
import styled from "styled-components";
import { FieldConfig } from "formik";
import Icon from "../Icon/Icon";
import FormInput from "./FormInput";

const Wrapper = styled.div`
  position: relative;
`;

const IconWrapper = styled.span`
  position: absolute;
  top: 9px;
  right: 15px;
  cursor: pointer;
`;

const StyledIcon = styled(Icon)`
  opacity: 0.5;
`;

interface IProps extends FieldConfig {
  className?: string;
}

const FormHiddenInput = ({
  className,
  ...props
}: IProps & React.HTMLProps<HTMLInputElement>) => {
  const [showContent, setShowContent] = useState(false);
  const toggleVisibility = () => setShowContent((value) => !value);

  return (
    <Wrapper className={className}>
      <FormInput {...props} type={showContent ? "text" : "password"} />
      <IconWrapper onClick={toggleVisibility}>
        <StyledIcon name={showContent ? "eyeOff" : "eyeOn"} />
      </IconWrapper>
    </Wrapper>
  );
};

export default FormHiddenInput;
